import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react"
import Cookies from 'js-cookie';
import { CountBadge } from '../../common/NumberBadge';
import { useAdminNotifi } from '../../../context/Admins/AdminNotifiContext';

export default function AdminHeaderNotifi() {
    const [isLogIn, setIsLogIn] = useState(false);
    const { orderNotifi } = useAdminNotifi();


    useEffect(() => {
        if (Cookies.get('adminToken')) {
            setIsLogIn(true)
        }
    }, [isLogIn]);

    const notifiRed = orderNotifi?.data?.result.filter((notifi) => !notifi.seen).length || 0;

    return (
        <>
            <Link className={`user-bell text-white bg-light-beige`} type='button'
                to={isLogIn && "/admin/adminNotifi"}>
                <FontAwesomeIcon icon={faBell} />
                {isLogIn && (notifiRed >= 1 && <CountBadge itemCount={notifiRed} />)}
            </Link>
        </>
    )
};



